export default "__VITE_ASSET__2dd9acac__"